import fetch from '../utils/fetch';

//查询机构
export function allCompany(params) {
    return fetch({
      method:'GET',
      url:'metaPermission/allCompany',
      params
    })
  }

//删除元数据授权
export function deleteMetaPermission(params) {
  return fetch({
    method:'POST',
    url:'metaPermission/deleteMetaPermission',
    data:params
  })
}

//分页查询元数据授权列表
export function metaPermissionListByPage(params) {
    return fetch({
      method:'GET',
      url:'metaPermission/metaPermissionListByPage',
      params
    })
  }


  //保存元数据授权 保存和修改用一个
export function saveMetaPermission(params) {
  return fetch({
    method:'POST',
    url:'metaPermission/saveMetaPermission',
    data:params
  })
}

//获取全部元数据
export function unPermissionMetaField(params) {
  return fetch({
    method:'GET',
    url:'metaPermission/unPermissionMetaField',
    params
  })
}
